<template>
    <div class="space-y-6 max-w-7xl mx-auto sm:px-6 lg:px-8">
        <div class="bg-white overflow-hidden shadow-sm sm:rounded-lg">
            <text-splitter @handle="onHandle"></text-splitter>
        </div>

        <word v-for="word in words" :value="word"></word>
    </div>
</template>

<script>
export default {
    data() {
        let wordString = new URLSearchParams(window.location.search).get('ord');

        return {
            words: wordString ? wordString.split(' ') : ['velkommen', 'til', 'tegnordboken'],
        }
    },

    methods: {
        onHandle(values) {
            this.words = values;
        }
    }
}
</script>
